const demoProfile = {
  "country": "CA",
  "display_name": "John Doe",
  "email": "johnDoe@email.com",
  "explicit_content": {
    "filter_enabled": false,
    "filter_locked": false
  },
  "external_urls": {
    "spotify": "https://open.spotify.com/user/johnDoe"
  },
  "followers": {
    "href": null,
    "total": 4
  },
  "href": "https://api.spotify.com/v1/users/johnDoe",
  "id": "JohnDoe01",
  "images": [
    {
      "height": null,
      "url": "https://images.unsplash.com/photo-1565193047451-150663ee22e1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80",
      "width": null
    }
  ],
  "product": "premium",
  "type": "user",
  "uri": "spotify:user:JohnDoe01"
}

export default demoProfile